// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"19":"header","119":"store","348":"footer","565":"subscriptions-packs","697":"news","720":"faq"}[chunkId] + ".client-script.css";
};